export default __webpack_public_path__ + "static/media/sony-wi-c200-in-person.fcae0131.png";